import { render, staticRenderFns } from "./ProxyAgreeTable.vue?vue&type=template&id=60bf1208&scoped=true&"
import script from "./ProxyAgreeTable.vue?vue&type=script&lang=ts&"
export * from "./ProxyAgreeTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyAgreeTable.vue?vue&type=style&index=0&id=60bf1208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf1208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
